enum ProgressNoteStatus {
  DELETED = 'DELETED',
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  SIGNED = 'SIGNED',
}

export default ProgressNoteStatus;
